'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var React = require('react');
var React__default = _interopDefault(React);
var MaterialTableHead = _interopDefault(require('@material-ui/core/TableHead'));

var TableHead = function (_a) {
    var children = _a.children, restProps = tslib_es6.__rest(_a, ["children"]);
    return (React__default.createElement(MaterialTableHead, tslib_es6.__assign({}, restProps), children));
};

exports.TableHead = TableHead;
